class PopularVehicles extends HTMLElement {
connectedCallback() {
  this.track = this.querySelector('.slider__track');
  this.prevButton = this.querySelector('.slider__button--prev');
  this.nextButton = this.querySelector('.slider__button--next');
  this.caption = this.querySelector('.slide-caption');
  this.captionLink = this.caption.querySelector('a');
  this.isAnimating = false;
  this.handleResize = this.recalculateSlideWidth.bind(this);

  window.addEventListener('resize', this.handleResize);
    // Recalculate slide width on resize

  requestAnimationFrame(() => {
    this.recalculateSlideWidth();
    this.track.style.transform = 'translateX(0px)';
  });

  this.prevButton.addEventListener('click', () => this.shift(-1));
  this.nextButton.addEventListener('click', () => this.shift(1));
}

  shift(direction) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    // Remove old clone if any
    const oldClone = this.track.querySelector('.slider__slide.is-clone');
    if (oldClone) oldClone.remove();

    const originals = Array.from(this.track.querySelectorAll('.slider__slide[data-original]'));
    const clone = direction === 1
      ? originals[0].cloneNode(true)
      : originals[originals.length - 1].cloneNode(true);

    clone.classList.add('is-clone');
    clone.removeAttribute('data-original');

    if (direction === 1) {
      this.track.appendChild(clone);
    } else {
      this.track.insertBefore(clone, this.track.firstElementChild);
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(-${this.slideWidth}px)`;
    }

    // Force reflow to apply transition
    void this.track.offsetHeight;

    this.updateActiveSlide(direction);

    this.track.style.transition = 'transform 0.4s ease';
    this.track.style.transform = direction === 1
      ? `translateX(-${this.slideWidth}px)`
      : `translateX(0px)`;

    setTimeout(() => {
      this.track.style.transition = 'none';

      // Remove clone and reorder slides
      const currentClone = this.track.querySelector('.slider__slide.is-clone');
      if (currentClone) currentClone.remove();

      const updatedOriginals = Array.from(this.track.querySelectorAll('.slider__slide[data-original]'));
      if (direction === 1) {
        this.track.appendChild(updatedOriginals[0]);
      } else {
        this.track.insertBefore(updatedOriginals[updatedOriginals.length - 1], this.track.firstElementChild);
      }

      this.track.style.transform = 'translateX(0px)';
      this.isAnimating = false;
    }, 400);
  }

  updateActiveSlide(direction) {
    // Remove all active classes
    this.track.querySelectorAll('.slider__slide').forEach(slide => {
      slide.classList.remove('is-active');
    });

    const realSlides = Array.from(
      this.track.querySelectorAll('.slider__slide[data-original]')
    );

    const slidesVisible = window.matchMedia('(min-width: 990px)').matches ? 3 : 1;
    let target;

    if (slidesVisible === 1) {
      target = direction === 1
        ? realSlides[1]
        : realSlides[realSlides.length - 1];
    } else {
      target = direction === 1 ? realSlides[2] : realSlides[0];
    }

    if (target) {
      target.classList.add('is-active');
      const title = target.getAttribute('data-title') || '';
      const desc = target.getAttribute('data-text') || '';
      const link = target.getAttribute('data-link') || '';

      this.captionLink.innerHTML = `
        <h3 class="h6">${title}</h3>
        <p>${desc}</p>
      `;

      if (link) {
        this.captionLink.setAttribute('href', link);
        this.captionLink.classList.remove('empty-link');
        this.captionLink.removeAttribute('role');
      } else {
        this.captionLink.removeAttribute('href');
        this.captionLink.classList.add('empty-link');
        this.captionLink.setAttribute('role', 'link');
      }

    }
  }
  
  recalculateSlideWidth() {
    const slide = this.track.querySelector('.slider__slide');
    if (slide) {
      this.slideWidth = slide.getBoundingClientRect().width;
    }
  }
}

customElements.define('popular-vehicles', PopularVehicles);
